import { selectEffectiveYear } from '../../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { PropertyGridFieldProps } from './types.ts';
import { EditableField } from './EditableField.tsx';

export const AgeWithYearBuiltField = ({
  columnIndex,
  field,
  control,
  getValues,
  setValue,
  colSpan,
}: PropertyGridFieldProps) => {
  const effectiveYear = useAppSelector((state) => selectEffectiveYear(state));

  const toDisplayValue = (value?: number) => {
    if (value === undefined) return undefined;
    const yearBuilt = effectiveYear ? parseInt(effectiveYear, 10) - value : undefined;
    const suffix = value === 1 ? 'yr' : 'yrs';

    return yearBuilt ? `${value} ${suffix} (${yearBuilt})` : `${value} ${suffix}`;
  };

  const toEditValue = (value?: number) => {
    if (value === undefined) return undefined;
    return value.toString();
  };

  const toValue = (value?: string) => {
    if (value === undefined) return undefined;
    return parseInt(value, 10);
  };

  return <EditableField
    colSpan={colSpan}
    columnIndex={columnIndex}
    field={{
      ...field,
      toDisplayValue,
      toEditValue,
      toValue,
    }}
    control={control}
    getValues={getValues}
    setValue={setValue}
  />;
};
